import Vue from 'vue'

export default {
  namespaced: true,
  state: {
    viewMode: localStorage.getItem('view-mode') || 'grid',
    // eslint-disable-next-line radix
    currentFolder: parseInt(localStorage.getItem('current-folder')) || 0,
    // eslint-disable-next-line radix
    currentObject: parseInt(localStorage.getItem('current-object')) || 0,
    uploadMethod: localStorage.getItem('upload-method') || 'new', // new || copy
    // selectedFiles_ids: [],
  },
  getters: {
    // selectedFiles_ids(state) {
    //   return state.selectedFiles_ids
    // },
    currentFolder(state) {
      return state.currentFolder
    },
    viewMode(state) {
      return state.viewMode
    },
    currentObject(state) {
      return state.currentObject
    },
  },
  mutations: {
    UPDATE_VIEWMODE(state) {
      state.viewMode = state.viewMode === 'grid' ? 'table' : 'grid'
      localStorage.setItem('view-mode', state.viewMode)
    },
    UPDATE_CURRENT_FOLDER(state, payload) {
      // console.log('UPDATE_CURRENT_FOLDER 1', state.currentFolder)
      Vue.set(state, 'currentFolder', payload.currentFolder)
      localStorage.setItem('current-folder', state.currentFolder)
      // console.log('UPDATE_CURRENT_FOLDER 2', state.currentFolder)
    },
    UPDATE_CURRENT_OBJECT(state, payload) {
      Vue.set(state, 'currentObject', payload.currentObject)
      localStorage.setItem('current-object', state.currentObject)
    },
    UPDATE_UPLOAD_METHOD(state, payload) {
      Vue.set(state, 'uploadMethod', payload.uploadMethod)
      localStorage.setItem('upload-method', state.uploadMethod)
    },
    // UPDATE_TOGGLE_SELECTEDIDS(state, payload) {
    //   // eslint-disable-next-line camelcase
    //   const selectedFiles_ids = Vue.get(state, 'selectedFiles_ids')
    //   console.log(selectedFiles_ids)
    // },
  },
  actions: {},
}
